import { render } from "./Home.vue?vue&type=template&id=7f40ec21&scoped=true"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=7f40ec21&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7f40ec21"

export default script